import { useRef } from "react";
import { api } from "../actions/api";
import { useLocalizationContext } from "../components/providers/LocalizationProvider";

export const useDebouncedApiValidation = ({ url, ...rest }) => {
    const timeout = useRef();
    const abortController = useRef();
    const { translate } = useLocalizationContext();

    return (value, ctx) => {
        clearTimeout(timeout.current);
        abortController.current?.abort();
        abortController.current = typeof AbortController === "undefined" ? AbortController : new AbortController();

        return new Promise(resolve => {
            timeout.current = setTimeout(() => {
                api.post(url + "/" + value, rest, { signal: abortController.current?.signal })
                    .then(resolve)
                    .catch((e) => e.response && resolve(ctx.createError({ message: translate(e.response?.data?.error || "Oops, something went wrong!") })));
            }, 800);
        });
    };
};
